export const COMPANY_SUBSCRIPTION_STATUS_URL = '/companies';

export const STRIPE_SESSION_URL = '/payments';

export const USER_SUBSCRIPTION_INFO_URL = '/users';

export const USER_CERTIFICATION_EXAM_VERIFICATION_URL = '/users/verify-user-certification-exam-purchase';

export enum PaymentPendingType {
  // Chargebee
  PremiumSubscription = 'premium-subscription',
  BusinessSubscription = 'business-subscription',
  SetupBusinessSubscription = 'setup-business-subscription',
  SetupBusinessCheckout = 'setup-business-checkout',
  // Chargebee one time
  CloudAddon = 'cloud-addon',
  CertificationExam = 'certification-exam',
  // Stripe
  RoomPurchase = 'room-purchase',
  SubscriptionVoucher = 'subscription-voucher',
}
